export default {
  title: "",
  subtitle: "",
  path: "company_show",
  paragraph: "And this other one to check all details and information of a specific company: ",
  request:  {
      method: "GET", 
      endpoint: "/subject/companies/:id",
          responses: {
      "data": {
            "updated_at": "2025-02-10T08:55:35.770428",
            "status": "approved",
            "social_name": "Company Social Name LTDA",
            "required_clearance_level": 2,
            "references": [],
            "phone_number": "99812-1212",
            "phone_country_code": "55",
            "phone_area_code": "18",
            "partners": [],
            "net_value": "10000.00",
            "net_monthly_average_income": "4000.00",
            "main_activity": "8599603 - Treinamento em informática",
            "inserted_at": "2021-03-11T19:29:29.785250",
            "id": "577ff176-cbc4-4490-ad70-9a8d1a1d4006",
            "fiscal_country": "Brasil",
            "email": "company@email.com",
            "documents": [],
            "document_type": "cnpj",
            "document_number": "45215604065562",
            "creation_date": "2015-04-01",
            "company_type": "Ltda",
            "company_name": "Company Fantasy Name",
            "clearance_level": 2,
            "address_street": "Rua Barão do Rio Branco",
            "address_state": "SP",
            "address_postal_code": "16201220",
            "address_number": "310",
            "address_neighborhood": "gdhg",
            "address_country": "BR",
            "address_complement": null,
            "address_city": "Birigui",
            "activity_type": "other"
        }
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/documentation/data/SubjectCompanies/CompaniesListByID.js